module.exports = __webpack_public_path__ + "Icon_Business Units.f0837bad4212402d22b6.png";